import React from 'react';
import { CheckIcon } from 'lucide-react';
import { tomos, tomoIncludes } from '../data/tomos';
import { Emoji } from './Emoji';
export function Tomos() {
  return <section id="megapack" className="w-full bg-canvas py-14 sm:py-16" data-id="element-267" data-mp="139ux0dw7a57k">
      <div className="mx-auto w-full max-w-[680px] px-4 text-center sm:px-6 lg:max-w-[900px]" data-id="element-268" data-mp="1h4njxxef6no6">
        <h2 className="font-display text-[clamp(1.6rem,6vw,2.5rem)] font-extrabold uppercase leading-[1.05] tracking-tight text-ink-900" data-id="element-269" data-mp="1cat63alhx2x0">
          MegaPack Cocina Proteica Lista
        </h2>
        <p className="mt-3 font-display text-[clamp(1.15rem,4.5vw,1.875rem)] font-extrabold tracking-tight text-celeste-600" data-id="element-270" data-mp="1m1e0elu4zla4">
          6 Tomos + 6 Bonos — Todo resuelto.
        </p>

        <ul className="mt-8 grid grid-cols-3 gap-2.5 sm:grid-cols-6 sm:gap-3" data-id="element-271" data-mp="1w1emgfje4fi0">
          {tomos.map(tomo => <li key={tomo.number} className="flex h-20 flex-col justify-end rounded-lg p-2 shadow-card sm:h-28" style={{
          backgroundColor: tomo.accent
        }} data-id="element-272" data-mp="5op9bp3lftku">
              <span className="font-display text-[10px] font-extrabold uppercase leading-tight tracking-tight text-ink-900 sm:text-[11px]" data-id="element-273" data-mp="34saxtpkeaofd">
                {tomo.tag}
              </span>
            </li>)}
        </ul>

        <div className="mt-8 rounded-3xl border border-line bg-white px-4 py-6 text-left shadow-card sm:px-7 sm:py-8" data-id="element-274" data-mp="3en30h7su41h0">
          <p className="inline-flex items-center gap-2 font-display text-base font-extrabold uppercase tracking-[0.16em] text-celeste-700 sm:text-lg" data-id="element-275" data-mp="3of8o65c1zwqe">
            <Emoji symbol="💪" data-id="element-276" data-mp="3sehibbb09wmh" />
            Los 6 tomos completos
          </p>

          <ol className="mt-6 flex flex-col gap-7 lg:grid lg:grid-cols-2 lg:gap-8" data-id="element-277" data-mp="1bawr8owve14">
            {tomos.map(tomo => <li key={tomo.number} className="flex gap-3 sm:gap-4" data-id="element-278" data-mp="68b21hdxscr6">
                <span aria-hidden="true" className="mt-1.5 h-3.5 w-3.5 shrink-0 rounded-[3px] sm:h-4 sm:w-4" style={{
              backgroundColor: tomo.accent
            }} data-id="element-279" data-mp="232e7rz2pqum7" />
                <div className="min-w-0" data-id="element-280" data-mp="2001geckam9ay">
                  <h3 className="font-display text-[14px] font-extrabold leading-snug text-ink-900 sm:text-[15px]" data-id="element-281" data-mp="1vyfvq51ioqq7">
                    <Emoji symbol={tomo.emoji} className="mr-2" data-id="element-282" data-mp="29y7esk6w4xb2" />
                    Tomo {tomo.number} —{' '}
                    <span className="uppercase" data-id="element-283" data-mp="24xt4evhthb9v">{tomo.title}</span>
                  </h3>

                  <ul className="mt-3 flex flex-col gap-2" data-id="element-284" data-mp="2ixu9yo9116vo">
                    {tomo.bullets.map(bullet => <li key={bullet} className="flex items-start gap-2.5 text-[13px] leading-snug text-ink-700 sm:text-[14px]" data-id="element-285" data-mp="2ew907brsh8pp">
                        <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-celeste-600" data-id="element-286" data-mp="2nqnaezxgpt1y">
                          <CheckIcon className="h-2.5 w-2.5 text-white" strokeWidth={4} aria-hidden="true" data-id="element-287" data-mp="32kihc0e258ai" />
                        </span>
                        <span className="min-w-0" data-id="element-288" data-mp="3lb6rw5atls2v">{bullet}</span>
                      </li>)}
                  </ul>
                </div>
              </li>)}
          </ol>
        </div>

        <p className="mx-auto mt-8 flex max-w-xl flex-wrap items-center justify-center gap-2 font-display text-base font-extrabold tracking-tight text-ink-900 sm:text-xl" data-id="element-289" data-mp="3c8xff9vzromu">
          6 tomos. 6 situaciones distintas de tu semana. Un solo sistema que las
          resuelve todas.
          <Emoji symbol="🍗" data-id="element-290" data-mp="2olflp8t62gh8" />
        </p>

        <div className="mt-10 rounded-3xl border border-celeste-300 bg-celeste-100 px-5 py-7 text-left sm:px-8 sm:py-8" data-id="element-291" data-mp="2omh5c1o90bak">
          <h3 className="text-center font-display text-base font-extrabold uppercase tracking-[0.12em] text-ink-900 sm:text-lg" data-id="element-292" data-mp="2emgkucen7p4s">
            Cada tomo incluye
          </h3>
          <ul className="mt-6 grid gap-4 sm:grid-cols-2" data-id="element-293" data-mp="2jkrtijt7btlf">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-294" data-mp="3myjryi9exuea">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-celeste-600" data-id="element-295" data-mp="3hyfd0wo5l7q6">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-296" data-mp="3d4t6znchw23c" />
                </span>
                <span className="min-w-0 text-[14px] font-medium leading-relaxed text-ink-700 sm:text-[15px]" data-id="element-297" data-mp="33a16obrj314v">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}